import React from 'react';

class TooltipContainer extends React.Component {
    constructor(props) {
        super(props);

        this.handleTooltip = this.handleTooltip.bind(this);
    }

    handleTooltip(el) {
        function ancestor(el, cls) {
            while ((el = el.parentElement) && !el.classList.contains(cls));
            return el;
        }

        this.tooltipShowing = !this.tooltipShowing;

        let placeholder;
        const formGroup = ancestor(el.currentTarget, 'form-group');
        formGroup && (placeholder = formGroup.querySelector('.placeholder-tooltip-hidden'));

        placeholder && placeholder.classList[this.tooltipShowing ? 'add' : 'remove']('is-showing');
    }

    render() {
        this.tooltipShowing = false;

        return (
            <div style={{ display: 'inline' }}>
                {this.props.data.placeholder &&
                    this.props.data.placeholderHidden && (
                        <div className="tooltip-blob-container">
                            <div className="tooltip-blob" onClick={this.handleTooltip} />
                        </div>
                    )}
            </div>
        );
    }
}

export default TooltipContainer;
